import { NgModule } from '@angular/core';
import { TestRegistryService } from './services/test-registry.service';

// Import test modules
import { AITestsModule } from './modules/ai-tests/ai-tests.module';
import { APITestsModule } from './modules/api-tests/api-tests.module';
import { UtilityTestsModule } from './modules/utility-tests/utility-tests.module';

/**
 * Main test bench module that imports all test modules
 * This module is responsible for registering all tests with the TestRegistryService
 */
@NgModule({
  imports: [
    // Import all test modules to register their tests
    AITestsModule,
    APITestsModule,
    UtilityTestsModule
  ],
  providers: [
    TestRegistryService
  ]
})
export class TestBenchModule {
  
  constructor(private testRegistry: TestRegistryService) {
    console.log('Test bench module initialized');
    
    // Add a small delay to ensure all modules have registered their tests
    setTimeout(() => {
      console.log('Total categories:', this.testRegistry.getAllCategories().length);
      console.log('Total tests:', this.testRegistry.getAllTests().length);
    }, 100);
  }
}

// Export the main component and services for standalone usage
export { TestBenchRefactoredComponent } from './test-bench-refactored.component';
export { TestRegistryService } from './services/test-registry.service';
export { TestControl, TestCategory } from './models/test-control.interface';

/**
 * Bootstrap function for standalone usage
 * This function can be called to initialize the test bench without using NgModule
 */
export function bootstrapTestBench(): void {
  console.log('Test bench bootstrapped for standalone usage');
  // This would be called when using the component in a standalone context
}